import * as actionTypes from './actionTypes';

export interface I_ProductLabel {
    //產品標籤
    type: string | null; //type: PLAN,TRAIN,BOATS,BUS,CRS,WALK
    name: string;
}

export interface I_Tag {
    TagName: string;
    TagSort: number;
}

export interface I_TripType {
    Name: string;
    Code: string;
}

export interface I_RecommendList {
    ImgUrl?: string; // 圖片路徑
    ProductType?: string; // 1:主題旅遊 2:國外團體 3:台灣團體 4:團體自由行(不分國內外)
    TourName?: string; // 行程名稱
    TourDays?: number; // 行程天數
    Airline?: string; // 航空公司
    ProductLabelList?: I_ProductLabel[];
    Price?: string | number; // 價格
    TagList?: I_Tag[]; // 標籤清單
    TripTypeList?: I_TripType[]; // 旅遊型態 EXAPI PD93 增加回傳TripTypeList
    ImgM?: string;
    GroupList?: any;
    Status?: number;
    NormGroupID?: string;
    GroupStraightPrice?: number | string; // 最低價格
}

export interface I_Recommend {
    recommendList: I_RecommendList[];
    isLoading: boolean;
}

const initialState: I_Recommend = { recommendList: [], isLoading: true };

const recommendReducer = (state: I_Recommend = initialState, action: any): I_Recommend => {
    switch (action.type) {
        case actionTypes.SET_RECOMMENDS_SYNC:
        case actionTypes.SET_RECOMMENDS_SUCCESS:
            return { recommendList: action.payload, isLoading: false };
        case actionTypes.SET_RECOMMENDS:
            return { ...state, recommendList: action.recommends };
        case actionTypes.GET_RECOMMENDS:
            return { ...state, recommendList: action.recommends };
        case actionTypes.REMOVE_RECOMMEND:
            return {
                ...state,
                recommendList: state.recommendList.filter(
                    (recommend: I_RecommendList, i: number) => i !== action.index
                ),
            };
        case actionTypes.GET_JSONPLACEHOLDER:
            return state;
        default:
            return state;
    }
};

export default recommendReducer;
